import React from "react";

export default function UploaderPagination({ currentPage, totalPages, onPageChange }) {
  const maxVisible = 3;

  // Calculate visible range
  let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
  let endPage = startPage + maxVisible - 1;
  if (endPage > totalPages) {
    endPage = totalPages;
    startPage = Math.max(1, endPage - maxVisible + 1);
  }

  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  const handleClick = (page) => {
    if (page >= 1 && page <= totalPages && page !== currentPage) {
      onPageChange(page);
    }
  };

  return (
    <div style={{display:"flex",justifyContent:"center",gap:"5px"}}>
      {/* Prev Button */}
      <button
        onClick={() => handleClick(currentPage - 1)}
        disabled={currentPage === 1}
        style={{border:"2px solid rgba(144, 202, 249,1)" ,background:"#fff"}}
      >
        Prev
      </button>

      {/* Page Numbers */}
      {pages.map((page) => (
        <button
          key={page}
          onClick={() => handleClick(page)}
          style={{border:`${
            page === currentPage
              ? "2px solid rgba(144, 202, 249,1)"
              : "2px solid rgba(144, 202, 249,1)"
          }`,background:`${
            page === currentPage
              ? "rgba(144, 202, 249,1)"
              : "#ffffff"
          }`}}
          
        >
          {page}
        </button>
      ))}

      {/* Next Button */}
      <button
        onClick={() => handleClick(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="" style={{border:"2px solid rgba(144, 202, 249,1)" ,background:"#fff"}}
      >
        Next
      </button>
    </div>
  );
}